import { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { subscriptionService } from '../service/SubscriptionService';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';

const SubscriptionSuccess = () => {
  const location = useLocation();
  const history = useHistory();
  const [error, setError] = useState<string | null>(null);
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    const verifySubscription = async () => {
      try {
        // Get the session ID from URL parameters
        const params = new URLSearchParams(location.search);
        const sessionId = params.get('session_id');
        if (!sessionId) {
          throw new Error('Aucun ID de session trouvé');
        }

        // Add a small delay to allow webhook processing
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Verify the subscription status
        await subscriptionService.getCurrentSubscription();
        
        // Redirect to parameters page after successful verification
        setTimeout(() => {
          history.replace('/parameters');
        }, 1000);
      } catch (error) {
        console.error('Subscription verification error:', error);
        setError(error instanceof Error ? error.message : 'Une erreur est survenue lors de la vérification de votre abonnement');
        // Redirect to parameters page after showing error
        setTimeout(() => {
          history.replace('/parameters');
        }, 3000);
      } finally {
        setVerifying(false);
      }
    };

    verifySubscription();
  }, [location, history]);

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <Card className="w-full max-w-md">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Erreur d'abonnement</h2>
            <p className="text-gray-600">{error}</p>
            <p className="mt-4 text-sm text-gray-500">Redirection vers la page des paramètres...</p>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50 success-page">
      <Card className="w-full max-w-md">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-green-600 mb-4">
            {verifying ? 'Traitement de votre abonnement...' : 'Abonnement réussi !'}
          </h2>
          {verifying && (
            <div className="flex justify-center mb-4">
              <ProgressSpinner style={{ width: '50px', height: '50px' }} />
            </div>
          )}
          <p className="text-gray-600">
            {verifying 
              ? 'Veuillez patienter pendant que nous vérifions votre abonnement...'
              : 'Votre abonnement a été traité avec succès.'}
          </p>
          <p className="mt-4 text-sm text-gray-500">Vous serez redirigé dans quelques instants.</p>
        </div>
      </Card>
    </div>
  );
};

export default SubscriptionSuccess;
